/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { JSXElement } from 'solid-js';
import { Component, Show, For, createSignal } from 'solid-js';
import { translate as t } from '@fulcrum/lib';

export interface ChipsProps {
  chips: string[];
  limit?: number;
  chipShape?: 'REGULAR' | 'RECTANGLE';
}

const Chips: Component<ChipsProps> = (props): JSXElement => {
  let chipsRef: HTMLDivElement | undefined;
  const [showAll, setShowAll] = createSignal(false);

  // TODO: Fix type of chips to avoid unnecessary condition eslint error
  const getChips = () => props.chips || [];
  // eslint-disable-next-line no-magic-numbers
  const getLimit = () => props.limit || 5;
  const getChipShape = () => props.chipShape || 'REGULAR';

  const items = () =>
    showAll() ? getChips() : getChips().slice(0, getLimit());

  const toggleShowAll = () => {
    const newShowAll = !showAll();
    setShowAll(newShowAll);

    // Emit custom event for React wrapper
    if (chipsRef) {
      const event = new CustomEvent('toggle', {
        detail: { showAll: newShowAll },
        bubbles: true,
      });
      chipsRef.dispatchEvent(event);
    }
  };

  const getClassNames = (
    base: string,
    conditional: Record<string, boolean> = {}
  ) => {
    const classes = [base];
    Object.entries(conditional).forEach(([key, value]) => {
      if (value) classes.push(key);
    });
    return classes.join(' ');
  };

  return (
    <div ref={chipsRef}>
      <ul class="flex-row-wrap">
        <Show when={items().length > 0} fallback={<span>--</span>}>
          <For each={items()}>
            {(chip) => (
              <li
                class={getClassNames('chips non-editable', {
                  rectangle: getChipShape() === 'RECTANGLE',
                })}
              >
                <span title={chip}>{chip}</span>
              </li>
            )}
          </For>
        </Show>
      </ul>
      <Show when={getChips().length > getLimit()}>
        <div>
          <button
            class="button link-primary inline-left"
            onClick={toggleShowAll}
          >
            {showAll() ? t('TC.Common.ShowLess') : t('TC.Common.ShowAll')}
          </button>
        </div>
      </Show>
    </div>
  );
};

export default Chips;
